import posthog from 'posthog-js';

type MarketingEvent = '$pageview' | 'section_opened' | 'pricing_calculated' | 'quote_requested' | 'enquiry_submitted' | 'enquiry_failed';
type MarketingProperties = { section?: string; plan?: string; employee_band?: string };

let initialized = false;

export function employeeBand(count: number): string {
  if (count <= 25) return '15–25';
  if (count <= 100) return '26–100';
  if (count <= 500) return '101–500';
  if (count <= 1000) return '501–1000';
  return '1000+';
}

export function initializeMarketingAnalytics(): void {
  const key = process.env.REACT_APP_POSTHOG_KEY;
  const host = process.env.REACT_APP_POSTHOG_HOST;
  if (initialized || !key || !host || process.env.NODE_ENV !== 'production' || window.location.pathname !== '/') return;

  try {
    posthog.init(key, {
      api_host: host,
      persistence: 'memory',
      person_profiles: 'never',
      autocapture: false,
      capture_pageview: false,
      capture_pageleave: false,
      capture_exceptions: false,
      capture_dead_clicks: false,
      capture_performance: false,
      disable_session_recording: true,
      disable_surveys: true,
      disable_external_dependency_loading: true,
      advanced_disable_flags: true,
      ip: false,
      before_send: (event) => {
        if (!event || window.location.pathname !== '/') return null;
        // Never forward query strings, referrers, form values or admin URLs.
        event.properties = {
          token: event.properties.token,
          distinct_id: event.properties.distinct_id,
          $lib: event.properties.$lib,
          $lib_version: event.properties.$lib_version,
          $current_url: `${window.location.origin}/`,
          $pathname: '/',
          $host: window.location.host,
          $process_person_profile: false,
          $geoip_disable: true,
          section: event.properties.section,
          plan: event.properties.plan,
          employee_band: event.properties.employee_band,
        };
        return event;
      },
    });
    initialized = true;
    trackMarketingEvent('$pageview');
  } catch {
    // Analytics must never interrupt navigation or lead submission.
  }
}

export function trackMarketingEvent(event: MarketingEvent, properties: MarketingProperties = {}): void {
  if (!initialized || window.location.pathname !== '/') return;
  try {
    posthog.capture(event, properties);
  } catch {
    // The website remains usable when analytics is unavailable.
  }
}
